export const c_masthead_m_display_stack__main_before_BorderBottom = {
  "name": "--pf-c-masthead--m-display-stack__main--before--BorderBottom",
  "value": "1px solid #6a6e73",
  "var": "var(--pf-c-masthead--m-display-stack__main--before--BorderBottom)"
};
export default c_masthead_m_display_stack__main_before_BorderBottom;